import React from "react";
import { createPortal } from "react-dom";
import { Book, X } from "lucide-react";
import PayrollGuide from "../../PayrollGuide";
import { C, FONT } from "../styles";

interface PayrollGuideSheetProps {
  onClose: () => void;
}

export default function PayrollGuideSheet({ onClose }: PayrollGuideSheetProps) {
  return createPortal(
    <>
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(16,26,43,0.25)",
          zIndex: 1000,
          animation: "novalaFadeIn 0.22s ease-out",
        }}
      />
      <div
        style={{
          position: "fixed",
          bottom: 20,
          right: 20,
          height: "85vh",
          width: "min(440px, calc(100vw - 40px))",
          background: C.surface,
          boxShadow:
            "0 -12px 40px rgba(16,26,43,0.28), 0 6px 20px rgba(16,26,43,0.18)",
          borderRadius: 18,
          zIndex: 1001,
          display: "flex",
          flexDirection: "column",
          animation: "novalaSlideUpRight 0.3s ease-out",
          fontFamily: FONT,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            background: "linear-gradient(135deg, " + C.teal + ", " + C.tealD + ")",
            flex: "0 0 auto",
            padding: "16px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderRadius: "18px 18px 0 0",
          }}
        >
          <div
            style={{
              fontSize: 15,
              fontWeight: 600,
              color: "#fff",
              display: "inline-flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <Book size={16} /> Payroll guide
          </div>
          <button
            onClick={onClose}
            title="Close"
            style={{
              background: "rgba(255,255,255,0.15)",
              border: "1px solid rgba(255,255,255,0.25)",
              borderRadius: "50%",
              width: 30,
              height: 30,
              cursor: "pointer",
              color: "#fff",
              display: "grid",
              placeItems: "center",
            }}
          >
            <X size={14} />
          </button>
        </div>
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            minHeight: 0,
            WebkitOverflowScrolling: "touch",
          }}
        >
          <PayrollGuide embeddedInPanel onClose={onClose} />
        </div>
      </div>
      <style>{`
        @keyframes novalaFadeIn { from { opacity: 0; } to { opacity: 1; } }
        @keyframes novalaSlideUpRight { from { transform: translateY(calc(100% + 30px)); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
      `}</style>
    </>,
    document.body
  );
}